import React from 'react';
import { ReactComponent as CardIcon } from '../../../assets/images/icons/card.svg';
import { useTranslation } from 'react-i18next';
import { useTheme } from '@mui/material';
import { useAppDispatch } from '../../../app/hooks';
import { changeStep } from '../../../app/slices/step.slice';

const TRANSLATION_PREFIX = 'steps.bank-auth-type-selection';

const BankIdent = () => {
	const theme = useTheme();
	const { t } = useTranslation();

	const dispatch = useAppDispatch();

	const handleSubmit = () => {
		dispatch(changeStep('BANK_STEP'));
	};

	return (
		<div id="id-autria-auth" className="flex w-full justify-between items-start">
			<div className="flex flex-col items-start">
				<div className="flex items-center gap-1 ml-1.5">
					<CardIcon stroke={theme.palette.primary.main} width={40} height={40} />
					<p className="ml-[1.5rem] text-sm font-[600] text-black">
						{t(`${TRANSLATION_PREFIX}.bank-ident-title`)}
					</p>
				</div>

				<p className="ml-[4.7rem] -mt-2 text-sm font-semi-bold italic whitespace-pre-line">
					{t(`${TRANSLATION_PREFIX}.bank-ident-description`)}
				</p>
			</div>

			<button
				onClick={handleSubmit}
				aria-label={`${t('button.next')} – ${t(`${TRANSLATION_PREFIX}.bank-ident-title`)}`}
				className="text-sm border px-1 py-0.5 rounded-md mt-1 border-gray-600 hover:bg-gray-100"
			>
				{t('button.next')}
			</button>
		</div>
	);
};

export default BankIdent;
